import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class SendTransactionsUserCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) {}

  run(user_id, receiver_user_id, num_transactions, contract_origin_id): Promise<{ [key: string]: string; }> {
    let args = {user_id:user_id, receiver_user_id:receiver_user_id, num_transactions:num_transactions, contract_origin_id:contract_origin_id};
    return this.dispatcher.dispatch('send.transactions.user', args)
  }
}